import { useStore } from "vuex"
import { ref, onMounted, watch, computed } from "vue"

const ACTIVE_STEP_CLASS = "kb-hero-general__step-indicator-circle--active-step"

export default {
    name: "PersonalFundraisingFlowStepHero",
    setup() {
        const store = useStore()
        
        const stepWrapper = ref(null)
        const steps = ref([])
        const currentStepIndex = ref(null)
        const storeStep = computed(() => store.state.fundraising.personalFundraisingFlowStep)

        watch(storeStep, (newStepNumber) => {

            var newStepIndex = newStepNumber - 1

            if (steps.value) {
                
                var newStepCircleElement = getCircleElement(steps.value[newStepIndex])
                newStepCircleElement.classList.add(ACTIVE_STEP_CLASS)

                if (currentStepIndex.value !== null)

                    var previousStepCircleElement = getCircleElement(steps.value[currentStepIndex.value])
                    previousStepCircleElement.classList.remove(ACTIVE_STEP_CLASS)
            }

            currentStepIndex.value = newStepIndex
        })

        const getCircleElement = (step) => {
            return step.querySelector(".kb-hero-general__step-indicator-circle")
        }

        onMounted(() => {
            steps.value = Array.from(stepWrapper.value.children)
            currentStepIndex.value = steps.value.findIndex(step => step.ariaCurrent === "step")
        })

        return {
            stepWrapper
        }
    }
}